module.exports = __webpack_public_path__ + "img/login.39dece5c.jpg";